import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import hardware from './modules/hardware';
import user from './modules/user';
import mtmUser from './modules/mtm-user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    hardware,
    user,
    mtmUser,
    app,
  },
});
